(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('es-photo-reviews'))customElements.define('es-photo-reviews',class extends HTMLElement{
    get track(){return this.querySelector('.es-photo-reviews__track');}
    get cards(){return [...this.querySelectorAll('.es-photo-reviews__card')];}
    get dots(){return [...this.querySelectorAll('[data-review-dot]')];}
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.paused=false;this.hovered=false;
      const move=direction=>{
        const max=this.track.scrollWidth-this.track.clientWidth;
        const step=this.cards[0]?.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);
        let target=this.track.scrollLeft+direction*step;
        if(direction>0&&this.track.scrollLeft>=max-2)target=0;
        if(direction<0&&this.track.scrollLeft<=2)target=max;
        this.track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      this.addEventListener('click',event=>{
        const button=event.target.closest('button');
        if(!button)return;
        if(button.hasAttribute('data-review-prev'))move(-1);
        if(button.hasAttribute('data-review-next'))move(1);
        if(button.hasAttribute('data-review-dot'))this.cards[Number(button.dataset.reviewDot)]?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest',inline:'start'});
        if(button.hasAttribute('data-review-pause')){
          this.paused=!this.paused;
          button.setAttribute('aria-pressed',String(this.paused));
          this.querySelector('[data-review-pause-label]').hidden=this.paused;
          this.querySelector('[data-review-play-label]').hidden=!this.paused;
        }
      },options);
      this.addEventListener('scroll',event=>{
        if(event.target!==this.track)return;
        const end=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;
        const left=this.track.getBoundingClientRect().left;
        let index=0,distance=Infinity;
        this.cards.forEach((card,i)=>{const delta=Math.abs(card.getBoundingClientRect().left-left);if(delta<distance){distance=delta;index=i;}});
        if(end&&this.track.scrollLeft>0)index=this.cards.length-1;
        this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
      },{...options,passive:true,capture:true});
      this.addEventListener('mouseenter',()=>this.hovered=true,options);
      this.addEventListener('mouseleave',()=>this.hovered=false,options);
      this.addEventListener('shopify:block:select',event=>{
        this.paused=true;
        event.target.closest('.es-photo-reviews__card')?.scrollIntoView({block:'nearest',inline:'nearest'});
      },options);
      if(this.dataset.autoplay==='true'&&this.cards.length>1)this.timer=setInterval(()=>{
        const rect=this.getBoundingClientRect();
        if(!this.paused&&!this.hovered&&!document.hidden&&!this.contains(document.activeElement)&&rect.bottom>0&&rect.top<innerHeight&&!matchMedia('(prefers-reduced-motion: reduce)').matches)move(1);
      },Number(this.dataset.interval)||8000);
    }
    disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.controller=null;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-testimonial-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('es-review-ribbon')) {
  customElements.define('es-review-ribbon', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-es-track]');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-es-prev]');
      this.next = this.querySelector('[data-es-next]');
      this.update = () => {
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        [this.previous, this.next].forEach(button => { if (button) button.hidden = !overflow; });
        if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      const move = direction => {
        const card = this.track.querySelector('[data-es-card]');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.previous?.addEventListener('click', () => move(-1), options);
      this.next?.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('[data-es-card]');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'auto' });
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
